import { useMyself } from "@api";
import { useLocalStorage } from "react-use";

const getPrivacyConsentStorageKey = (userId?: string | number) =>
  `privacy-consent-${userId}`;

export const usePrivacyConsent = () => {
  const { data: user } = useMyself();
  const storageKey = getPrivacyConsentStorageKey(user?.id);

  const [value, setValue] = useLocalStorage<boolean | undefined>(
    storageKey,
    undefined
  );

  const isReady = user?.id !== undefined;
  const hasConsented = !isReady || Boolean(value);

  const acceptConsent = () => {
    setValue(true);
  };

  return {
    hasConsented,
    acceptConsent,
  };
};
